import { Injectable } from '@angular/core';
import { DataSource } from '@angular/cdk/table';
import { CollectionViewer } from '@angular/cdk/collections';
import { Observable } from 'rxjs';
import {
  selectCurrentStageStudyVms,
  IStageStudyVM,
} from '@core/state/entities/study/stage-study.viewmodel';
import {  Store } from '@ngrx/store';
import { IAppState } from '@core/state/state.service';

@Injectable()
export class StageStudiesDataSource extends DataSource<IStageStudyVM> {
  constructor(private _store: Store) {
    super();
  }

  connect(collectionViewer: CollectionViewer): Observable<IStageStudyVM[]> {
    return this._store.select((selectCurrentStageStudyVms));
  }
  disconnect(collectionViewer: CollectionViewer): void {}
}
